import { render, staticRenderFns } from "./AccessOrganism.vue?vue&type=template&id=ab19876e&scoped=true&"
import script from "./AccessOrganism.vue?vue&type=script&lang=js&"
export * from "./AccessOrganism.vue?vue&type=script&lang=js&"
import style0 from "./AccessOrganism.vue?vue&type=style&index=0&id=ab19876e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab19876e",
  null
  
)

export default component.exports